function modalInit() {
	
	if( $('#modalW').length < 1 ) {
	
		var actions	= '<div id="actions"><div class="closeModal"></div><div class="movePrev"></div><div class="moveNext"></div></div>';
			modal	= '<div id="modalW"><div id="shroud">' + actions + '</div></div>';
		
		$('body').append(modal);
	
	}
	
}

function imagePrep(cont) {
	
	var	imgFullSrc	= cont.find('img').attr('data-full');
	
	cont.find('img').attr('src', imgFullSrc);
	
	return cont;
		
}

function modalBuild(cont) {
	
	$('.modal').remove();
	
	$('#modalW').append('<div class="modal">');
		
	modal		= $('.modal');
	
	imagePrep(cont);
	modal.html(cont);
	
	$('body').addClass('modalOpen');
	
}

function closeModal() {
	
	$('body').removeClass('modalOpen');
	
}

$('body').on('transitionend', '.modal', function(event) {
	
	if( event.originalEvent.propertyName == 'transform' ) {
		
		$('.old').remove();
		$('.modal').removeClass('in new offRight');
    
    }
    
});

function next() {
	
	if( $('.modal').length < 2 ) {
	
		var	curr		= $('.current');
			nextPiece	= curr.next('.piece');
			cont 		= nextPiece.find('.cont').clone();
		
		if( nextPiece.length > 0 ) {
		
			curr.removeClass('current');
			nextPiece.addClass('current');
			
			imagePrep(cont);
			
			$('.modal').addClass('old').after('<div class="modal new offRight"></div>');
		
			$('.new').html(cont);
			
			$('.new img').load( function() { 
				
				setTimeout( function() {
				
					$('.new').addClass('in');
				
				}, 10);
				
			});
			
		}
	
	}
	
}

function prev() {
	
	if( $('.modal').length < 2 ) { 
	
		var	curr		= $('.current');
			prevPiece	= curr.prev('.piece');
			cont 		= prevPiece.find('.cont').clone();
		
		if( prevPiece.length > 0 ) {
		
			curr.removeClass('current');
			prevPiece.addClass('current');
				
			imagePrep(cont);
				
			$('.modal').addClass('old').before('<div class="modal new in"></div>');
		
			$('.new').html(cont);
			
			$('.new img').load( function() {
				
				$('.old').addClass('offRight');
				
			});
		
		}
	
	}
	
}

$('.piece').click( function() {
	
	$('.piece').removeClass('current');
	
	var	t 		= $(this),
		cont 	= t.find('.cont').clone();
	
	t.addClass('current');
	
	modalInit();
	modalBuild(cont);
	
});

$('body').on('click', '#shroud, .closeModal', function() {

	closeModal();

});

$('body').on('click', '.movePrev', function(e) {

	prev();
	e.stopPropagation();

});

$('body').on('click', '.moveNext', function(e) {
	
	next();
	e.stopPropagation();

});

jQuery(document).keydown(function(e) {
    
    if (e.keyCode === 27) { // escape
    
        closeModal();
        return false;
    
    } else if (e.keyCode === 37) { // left
    	
    	prev();
    	
    } else if (e.keyCode === 39) { // right
    	
    	next();
    	
    }
    
});